import { FormikProps } from "formik";
import styles from "./Input.module.css";
import ValidationMessage from "./ValidationMessage";

export default <T,>({ name, label, formik, children, className }: IInputContainerProps<T>) => {
    return (
        <div className={[styles.container, className].join(" ")}>
            {label && <label>{label}</label>}
            {children}
            {formik.touched[name] && formik.errors[name] && <ValidationMessage message={formik.errors[name] as string} />}
        </div>
    );
}

export const InputContainerRow = <T,>({ name, label, formik, children, className }: IInputContainerProps<T>) => {
    return (
        <div className={[styles.row, className].join(" ")}>
            <div className={styles.key}>{label}</div>
            <div className={[styles.value, styles.container].join(" ")}>
                {children}
                {formik.touched[name] && formik.errors[name] && <ValidationMessage message={formik.errors[name] as string} />}
            </div>
        </div>
    );
}

interface IInputContainerProps<T> {
    name: keyof T;
    label: string;
    formik: FormikProps<T>;
    children: React.ReactNode;
    className?: string;
}